import dayjs from 'utils/dayjs'
import { TIME_FORMAT } from 'utils/date'

export default function datetime(date) {
  return date ? dayjs(date).utc().format(`MMM D, YYYY・${TIME_FORMAT}`) : '–'
}
